// extracted by mini-css-extract-plugin
module.exports = {"products":"xT","productContainer":"yT","resultsHeading":"zT","oosMessaging":"AT"};